import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import auth from '../../../auth/';

import { TabContent, TabPane, Nav, NavItem, NavLink, Label, Input, FormFeedback, Button, Table } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaAsyncSeeker2 from "../../../components/ParadigmaAsyncSeeker_v2/ParadigmaAsyncSeeker"
import ParadigmaFileUploader from "../../../components/paradigmaFileUploader/ParadigmaFileUploader.js"
import ParadigmaCKEditor from '../../../components/ParadigmaCKEditor/ParadigmaCKEditor.js'

import InputMask from 'react-input-mask';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import moment from 'moment';

class CargaDatos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datos: [],
            datosDelete: [],
            aclaracionesDelete: [],
            aclaraciones: [],
            porcentaje: null,
            persona_id: null,
            persona_nombre: "",
            total: 0,
            solicitud_id: null,
            proyecto_codigo: null,
            montoAclaracion: "",
            resumen: "",
            fechaFin: moment(),
            fechaInicio: moment(),
            activeTab: 1,
            motivo: "",
            aclaracion: "",
            admin: (JSON.parse(localStorage.permisos).filter(x => x.indexOf('admin') != -1).length ? true : false),
            firma_id: null,
            file:{
                name:null,
                link:null
           }
        };

        this.EraseFile=this.EraseFile.bind(this);
        this.AppendDocument=this.AppendDocument.bind(this);
    }



    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            datos: [],
            datosDelete: [],
            aclaracionesDelete: [],
            aclaraciones: [],
            porcentaje: null,
            persona_id: null,
            persona_nombre: "",
            rol_id: null,
            rol_nombre: "",
            total: 0,
            solicitud_id: null,
            proyecto_codigo: null,
            montoAclaracion: "",
            resumen: "",
            fechaFin: moment(),
            fechaInicio: moment(),
            activeTab: 1,
            motivo: "",
            aclaracion: "",
            firma_id: null,
        })
    }

    getActiveClass(tabN) {
        if (this.state.activeTab == tabN)
            return "active";
        else
            return "";
    }

    toggleTab(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    setSelects(data) {

        var total = 0;
        data.datos.forEach(x => total += x.porcentaje);
        this.setState({
            datos: data.datos,
            total: total,
            solicitud_id: data.solicitud_id,
            resumen: (data.resumen != null ? data.resumen : ""),
            proyecto_codigo: data.codigo,
            fechaInicio: (data.fechaInicio != null ? moment(data.fechaInicio) : moment()),
            fechaFin: (data.fechaFin != null ? moment(data.fechaFin) : moment()),
            montoAclaracion: data.montoAclaracion,
            aclaraciones: (data.aclaraciones ? data.aclaraciones : []),
            firma_id: data.firma_id,
            file:{
                name: data.file.name !== undefined && data.file.name !== null ? data.file.name : null,
                link: data.file.link !== undefined && data.file.link !== null ? api.BASE_URL + data.file.link : null
           }
        });
    }

    AddToTable() {
        var datos = this.state.datos;

        var existdato = datos.filter(x => x.persona_id == this.state.persona_id && x.rol_id == this.state.rol_id);
        if (existdato.length > 0) {
            existdato[0].porcentaje += this.state.porcentaje;
        } else {
            datos.push({
                persona_id: this.state.persona_id,
                nombre: this.state.persona_nombre,
                rol_id: this.state.rol_id,
                rol_nombre: this.state.rol_nombre,
                porcentaje: this.state.porcentaje
            });
        }

        var total = 0;
        datos.forEach(x => total += x.porcentaje);

        this.setState({
            datos: datos,
            persona_id: 0,
            rol_id: 0,
            rol_nombre: "",
            persona_nombre: "",
            porcentaje: 0,
            total: total,
        })
    }

    onChangeInput(row, value) {
        var datos = this.state.datos;
        datos[row].porcentaje = parseInt(value);

        var total = 0;
        datos.forEach(x => total += x.porcentaje);
        if (total <= 100)
            this.setState({
                datos: datos,
                total: total
            });

    }

    removeRow(persona_id, rol_id) {
        var datos = this.state.datos.filter(x => x.persona_id != persona_id || x.rol_id != rol_id);
        var datosDelete = this.state.datosDelete;
        var newdatosDelete = this.state.datos.filter(x => x.persona_id == persona_id && x.rol_id == rol_id).filter(x => x.id != null).map(x => x.id);

        for (var i = 0; i < newdatosDelete.length; i++) {
            datosDelete.push(newdatosDelete[i]);
        }

        var total = 0;
        datos.forEach(x => total += x.porcentaje);
        this.setState({
            datos: datos,
            total: total,
            datosDelete
        });
    }

    changePorcentaje(e) {
        var value = parseInt(e.target.value);
        if (value > 0) {
            var total = 0;
            this.state.datos.forEach(x => total += x.porcentaje);
            if (total + value <= 100)
                this.setState({ porcentaje: value });
            else {
                this.setState({ porcentaje: 100 - total });
                e.preventDefault();
            }
        }
        else {
            this.setState({ porcentaje: 0 });
            e.preventDefault();
        }
    }

    AddAclaracion(e) {
        e.preventDefault();
        let { aclaraciones, motivo, aclaracion } = this.state;
        if (motivo != "" && aclaracion != "") {
            aclaraciones.push({ id: null, motivo: motivo, aclaracion: aclaracion });
            this.setState(prevState => {
                prevState.aclaraciones = aclaraciones;
                prevState.motivo = "";
                prevState.aclaracion = "";
                return prevState;
            });
        }
    }

    EraseFile(evt){
        this.setState({
             file:{
                  name:null,
                  link:null
             }
        });
   }

   AppendDocument(evt){
        if(evt.target.files !== undefined && evt.target.files.length == 1){
             let file = evt.target.files[0];
             this.setState({
                       file:{
                            name:file.name,
                            link:null
                       }
                  });
        }
   }

    render() {
        const { aclaraciones, admin } = this.state;
        var atr = [];
        if (this.state.datos) {
            for (var i = 0; i < this.state.datos.length; i++) {
                let rowN = i.toString();
                let row = this.state.datos[i];
                atr.push(
                    <tr key={i}>
                        <td className="d-none">
                            <Input type="number" name={"datos[" + rowN + "][id]"} className="p-0 d-none" value={row.id} onChange={(e) => this.onChangeInput(rowN, e.target)} />
                            <Input type="number" name={"datos[" + rowN + "][persona_id]"} className="p-0 d-none" value={row.persona_id} onChange={(e) => this.onChangeInput(rowN, e.target)} />
                            <Input type="number" name={"datos[" + rowN + "][rol_id]"} className="p-0 d-none" value={row.rol_id} onChange={(e) => this.onChangeInput(rowN, e.target)} />
                        </td>
                        <td>
                            <Button className="btn-round btn-small btn-danger mr-1" onClick={(e) => { e.preventDefault(); this.removeRow(row.persona_id, row.rol_id) }}><i className="fa fa-times"></i></Button>
                            {row.nombre}
                        </td>
                        <td>
                            {row.rol_nombre}
                        </td>
                        <td>
                            <Input type="number" name={"datos[" + rowN + "][porcentaje]"} value={row.porcentaje} onChange={(e) => this.onChangeInput(rowN, e.target.value)} className="form-control text-right" />
                        </td>
                    </tr>
                );
            }
        }

        return (
            <ParadigmaModal
                fileUploader={true}
                getUrl={api.proyectos.cargadatos.cargadatos}
                postUrl={api.proyectos.cargadatos.cargadatos}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Certificación ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Certificación"}
                buttonTitle={"Editar Certificación"}
                buttonIcon={"fa fa-list fa-lg"}
                notAllowedMessage={"La Certificación no puede ser editada en esta etapa porque ya fue avanzada."}

                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
                className={"ui-modal-dialog ui-modal-editor"}>
                <div className="ui-form">
                    <Nav tabs>
                        <NavItem>
                            <NavLink className={this.getActiveClass(1)} onClick={() => { this.toggleTab(1); }}>
                                Certificación
                            </NavLink>
                        </NavItem>
                        {admin ?
                            <NavItem>
                                <NavLink className={this.getActiveClass(2)} onClick={() => { this.toggleTab(2); }}>
                                    Aclaraciones
                            </NavLink>
                            </NavItem> : null}
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={1}>
                        <Input type="hidden" name="DatosDelete" onChange={(e) => { return; }} value={this.state.datosDelete.join(',')}></Input>
                        <Input type="hidden" name="AclaracionesDelete" onChange={(e) => { return; }} value={this.state.aclaracionesDelete.join(',')}></Input>

                        <div className="ui-section-grid">
                            <section className="ui-section-block ui-section-span-2">
                                <p className="ui-section-label">Datos del proyecto</p>
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                        <Label>Código</Label>
                                        <ParadigmaAsyncSeeker pkField={"codigo"} nombreField={"cod"} fieldName={""} url={api.proyectos.solicitudes.selectcodigo} value={this.state.proyecto_codigo} disabled={true} />
                                        <FormFeedback />
                                    </div>
                                </div>
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                        <Label>Proyecto</Label>
                                        <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select} value={this.state.solicitud_id} disabled={true} />
                                        <FormFeedback />
                                    </div>
                                </div>

                                <div className="ui-row-2">
                                    <div className="ui-field">
                                        <Label>Fecha Inicio</Label>
                                        <DatePicker
                                            selected={this.state.fechaInicio}
                                            onChange={(e) => this.setState({ 'fechaInicio': e })}
                                            timeFormat=""
                                            className="form-control"
                                            name={"fechaInicio"}
                                            timeIntervals={15}
                                            dateFormat="DD/MM/YYYY"
                                            timeCaption="time"
                                            customInput={<InputMask name="fechaInicio" className="form-control" mask="99/99/9999" type="text" />}
                                        />
                                        <FormFeedback />
                                    </div>
                                    <div className="ui-field">
                                        <Label>Fecha Fin</Label>
                                        <DatePicker
                                            selected={this.state.fechaFin}
                                            onChange={(e) => this.setState({ 'fechaFin': e })}
                                            timeFormat=""
                                            className="form-control"
                                            name={"fechaFin"}
                                            timeIntervals={15}
                                            dateFormat="DD/MM/YYYY"
                                            timeCaption="time"
                                            customInput={<InputMask name="fechaFin" className="form-control" mask="99/99/9999" type="text" />}
                                        />
                                        <FormFeedback />
                                    </div>
                                </div>
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                        <Label>Firma</Label>
                                        <ParadigmaAsyncSeeker clearable={true} fieldName={"firma_id"} url={api.proyectos.config.firmas.select} value={this.state.firma_id} />
                                        <FormFeedback />
                                    </div>
                                </div>
                            </section>

                            <section className="ui-section-block ui-section-span-2">
                                <p className="ui-section-label">Personal asignado</p>
                                <div className="ui-row-3">
                                    <div className="ui-field">
                                        <Label>Personal</Label>
                                        <ParadigmaAsyncSeeker2
                                            clearable={false}
                                            url={api.usuarios.personal.select}
                                            parameters={{
                                                paginationEnabled: false,
                                                sort: ['fullname']
                                            }}
                                            displayField="fullname"
                                            onChange={(data) => this.setState({persona_id: data.id, persona_nombre: data.fullname })}
                                            value={this.state.persona_id}
                                        />
                                    </div>
                                    <div className="ui-field">
                                        <Label>Rol</Label>
                                        <ParadigmaAsyncSeeker
                                            fieldName={""}
                                            nombreField={"nombre"}
                                            url={api.proyectos.config.roles.select}
                                            onChange={(data) => this.setState({ rol_id: data.pk, rol_nombre: data.nombre })}
                                            value={this.state.rol_id}
                                        />
                                    </div>
                                    <div className="ui-field">
                                        <Label>%</Label>
                                        <Input type="number" className="text-right" value={(this.state.porcentaje ? this.state.porcentaje : 0)} onChange={(e) => this.changePorcentaje(e)} ></Input>
                                    </div>
                                </div>
                                <Button style={{ borderRadius: '8px', marginBottom: '10px', backgroundColor: 'rgb(77, 189, 116)', color: 'white' }} onClick={(e) => { e.preventDefault(); this.AddToTable(); }}><i className={"fa fa-plus"}><label className="ml-2 text-white">Agregar</label></i></Button>
                                <Table className="ui-table table-sm">
                                    <thead>
                                        <tr>
                                            <th className="d-none">QUITAR</th>
                                            <th className="col-1">Persona</th>
                                            <th className="col-1">Rol</th>
                                            <th className="col-1">Porcentaje</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {atr}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colSpan="2" className="col-1">Total</th>
                                            <th colSpan="2" className="col-1">
                                                <Input type="number" className="text-right" disabled={true} onChange={(e) => { return; }}
                                                    value={(this.state.total ? this.state.total : 0)}></Input>
                                            </th>
                                        </tr>
                                    </tfoot>
                                </Table>
                            </section>

                            <section className="ui-section-block ui-section-span-2">
                                <p className="ui-section-label">Resumen</p>
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                <Label>Resumen</Label>
                                <ParadigmaCKEditor
                                    readOnly={false}
                                    isInForm={true}
                                    name={"resumen"}
                                    value={this.state.resumen}
                                    onValueChange={ (e) => this.setState({resumen: e})}
                                    className="GrowingEditor"
                                    fileTools_requestHeaders = { auth.header().headers }
                                    maxLength = {25000}
                                />
                                <FormFeedback />
                                    </div>
                                </div>
                            </section>

                        {
                            this.state.proyecto_codigo && (
                                this.state.proyecto_codigo.startsWith("V-") && (
                                        <section className="ui-section-block ui-section-span-2">
                                            <p className="ui-section-label">Carta de conformidad</p>
                                            <div className="ui-row-1">
                                                <div className="ui-field">
                                            <Label>Carta de Conformidad</Label>
                                            <ParadigmaFileUploader
                                            name="InformeAdjunto"
                                            onChange = {this.AppendDocument}
                                            erase = {this.EraseFile}
                                            link = {this.state.file.link}
                                            filename = {this.state.file.name}
                                            // acceptExtension = {"application/pdf"}
                                            // linkMessage={" Adjunto (.pdf): "}
                                            />
                                                </div>
                                            </div>
                                        </section>
                                )
                            )
                        }
                        </div>
                    </TabPane>
                    {/* {admin ? */}
                        <TabPane tabId={2}>

                            <div className="ui-section-grid">
                                <section className="ui-section-block ui-section-span-2">
                                    <p className="ui-section-label">Monto</p>
                                    <div className="ui-row-1">
                                        <div className="ui-field">
                                    <Label>Monto</Label>
                                    <Input type="text" className="text-left"
                                        name="montoAclaracion"
                                        onChange={(e) => this.setState({ montoAclaracion: e.target.value })}
                                        value={(this.state.montoAclaracion ? this.state.montoAclaracion : "")}
                                    ></Input>
                                        </div>
                                    </div>
                                </section>

                                <section className="ui-section-block ui-section-span-2">
                                    <p className="ui-section-label">Nueva aclaración</p>
                                    <div className="ui-row-2">
                                        <div className="ui-field">
                                    <Label>Motivo</Label>
                                    <Input type="text" className="text-left"
                                        value={(this.state.motivo ? this.state.motivo : "")}
                                        onChange={(e) => this.setState({ motivo: e.target.value })}
                                    ></Input>
                                        </div>
                                        <div className="ui-field">
                                    <Label>Aclaración</Label>
                                    <Input type="text" className="text-left"
                                        value={(this.state.aclaracion ? this.state.aclaracion : "")}
                                        onChange={(e) => this.setState({ aclaracion: e.target.value })}
                                    ></Input>
                                        </div>
                                    </div>
                                    <Button style={{ borderRadius: '8px', marginBottom: '10px', backgroundColor: 'rgb(77, 189, 116)', color: 'white' }} onClick={(e) => this.AddAclaracion(e)}
                                        ><i className={"fa fa-plus"}></i>
                                        <label className="ml-2 text-white">Agregar</label>
                                    </Button>
                                </section>

                                <section className="ui-section-block ui-section-span-2">
                                    <p className="ui-section-label">Aclaraciones</p>
                                    <Table className="ui-table table-sm">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Motivo</th>
                                                <th>Aclaración</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {aclaraciones && aclaraciones.map((row, i) =>
                                                <tr key={i}>
                                                    <td>
                                                        <Input type="hidden" name={"aclaraciones[" + i + "][id]"} className="p-0 d-none"
                                                            value={row.id} onChange={(e) => null} />
                                                        <Button className="btn-round btn-small btn-danger mr-1"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                let { aclaraciones, aclaracionesDelete } = this.state;
                                                                let aclaracion = aclaraciones[i];
                                                                if (aclaracion.id && aclaracion.id != "") aclaracionesDelete.push(aclaracion.id);
                                                                aclaraciones = aclaraciones.filter((y, j) => j !== i);
                                                                this.setState({ aclaraciones, aclaracionesDelete });
                                                            }}>
                                                            <i className="fa fa-times"></i>
                                                        </Button>
                                                    </td>
                                                    <td>
                                                        <Input type="text" name={"aclaraciones[" + i + "][motivo]"}
                                                            value={row.motivo}
                                                            onChange={(e) => {
                                                                let { aclaraciones } = this.state;
                                                                aclaraciones[i].motivo = e.target.value;
                                                                this.setState({ aclaraciones });
                                                            }} />
                                                    </td>
                                                    <td>
                                                        <Input type="text" name={"aclaraciones[" + i + "][aclaracion]"}
                                                            value={row.aclaracion}
                                                            onChange={(e) => {
                                                                let { aclaraciones } = this.state;
                                                                aclaraciones[i].aclaracion = e.target.value;
                                                                this.setState({ aclaraciones });
                                                            }
                                                            } />
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </section>
                            </div>
                        </TabPane>
                        {/* : null} */}
                    </TabContent>
                </div>
            </ParadigmaModal >
        );
    }
}

export default CargaDatos;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento5/CargaDatos.js